export default "__VITE_ASSET__adf36efe__"